import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function Articles() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Delve into the world of gourmet dining with First-Class.com. Find articles on culinary trends, cuisines, and restaurant recommendations'
          }
        />
        <title>Dining Articles: Explore Fine Dining and Cuisine</title>
      </Head>
      <ArticlesList subtype="Articles" type="Dining" />
    </>
  );
}

export default withLayout(Articles, true);
